import {VehicleForm as VFKit} from '../VehicleForm';

export function RegistrationNumberGroup() {
  return (
    <>
      <VFKit.SimpleTextField name="vehicleRegistrationNumber" />
      <VFKit.SimpleTextField name="registrationCertificateNumber" />
    </>
  );
}
